var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t外出申请-" + _vm._s(_vm.ruleForm.id != null && _vm.ruleForm.id != '' ? '修改' : '新增'))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "overflow-x": "hidden"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.txbm()
      }
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "80px",
      "width": "80%"
    },
    attrs: {
      "label": "姓名",
      "prop": "staff_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "595px"
    },
    model: {
      value: (_vm.ruleForm.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "staff_name", $$v)
      },
      expression: "ruleForm.staff_name"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "start_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.ruleForm.start_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "start_date", $$v)
      },
      expression: "ruleForm.start_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结束时间",
      "prop": "end_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.ruleForm.end_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "end_date", $$v)
      },
      expression: "ruleForm.end_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "外出时间(小时)",
      "prop": "travel_duration"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入外出时间"
    },
    model: {
      value: (_vm.ruleForm.travel_duration),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "travel_duration", $$v)
      },
      expression: "ruleForm.travel_duration"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "外出事由",
      "prop": "travel_reason"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "595px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入代岗原因"
    },
    model: {
      value: (_vm.ruleForm.travel_reason),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "travel_reason", $$v)
      },
      expression: "ruleForm.travel_reason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "照片",
      "prop": "name"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "limit": 1,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleAvatarSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.ruleForm.bank_photo,
      "alt": ""
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "200px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id == null || _vm.ruleForm.id == ''),
      expression: "ruleForm.id == null || ruleForm.id == ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存\n\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.UpdateAuditor
    }
  }, [_vm._v("\n\t\t\t\t\t\t修改\n\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择外出人",
      "visible": _vm.dialogVisibles,
      "width": "40%",
      "center": true,
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibles = $event
      }
    }
  }, [_c('el-row', [_c('organizeStaff', {
    ref: "organizeStaff",
    attrs: {
      "type": "radio",
      "accordion": false,
      "staff_id_prop": _vm.ruleForm.staff_ids
    },
    on: {
      "commit": _vm.saveChange
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['organizeStaff'].commit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d77e8ca4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Wcsq/Wcsq_add.vue
// module id = null
// module chunks = 